// extracted by mini-css-extract-plugin
export default {"searchControl":"searchControl---rtxIW","marginBottom0":"marginBottom0---s4bey","marginTop0":"marginTop0---v84c5"};